"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UIFireAlarm = _interopRequireDefault(require("UIComponents/alert/UIFireAlarm"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _Constants2 = require("../../Constants");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _Tiles = require("../../selectors/Tiles");

var _Tiles2 = require("../../utils/Tiles");

var _Filter = require("../../selectors/Filter");

var _FileExtensionFilters = _interopRequireDefault(require("../../enums/FileExtensionFilters"));

var _FilterHintMessage = _interopRequireDefault(require("./FilterHintMessage"));

var _hubLVideo = require("../../utils/hubLVideo");

var Actions = _interopRequireWildcard(require("../../actions/Actions"));

var _FoldersAndFilesContainer = _interopRequireDefault(require("../../containers/browser/FoldersAndFilesContainer"));

var _NoFiles = _interopRequireDefault(require("./NoFiles"));

var _SearchWithSuggestions = _interopRequireDefault(require("./SearchWithSuggestions"));

var _PickerVidyardBanner = _interopRequireDefault(require("./PickerVidyardBanner"));

var _PortalMeta = require("FileManagerCore/actions/PortalMeta");

var _Auth = require("FileManagerCore/selectors/Auth");

var _Suspension = require("FileManagerCore/selectors/Suspension");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _urls = require("FileManagerCore/utils/urls");

var _IdentityRepository = require("FileManagerCore/selectors/IdentityRepository");

var _PortalMeta2 = require("FileManagerCore/selectors/PortalMeta");

var _Files = require("FileManagerCore/selectors/Files");

var _Limits = require("FileManagerCore/selectors/Limits");

var _LoadingFailed = _interopRequireDefault(require("FileManagerCore/components/LoadingFailed"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var _network = require("../../utils/network");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

function getVideoLimitBannerI18nKey(suffix) {
  return "FileManagerLib.videoLimit.banner." + suffix;
}

var BrowsePanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BrowsePanel, _Component);

  function BrowsePanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BrowsePanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BrowsePanel).call(this, props));
    _this.state = {
      isVideoLimitBannerDismissed: false
    };
    _this.handleCloseVideoLimitBanner = _this.handleCloseVideoLimitBanner.bind((0, _assertThisInitialized2.default)(_this));
    _this.getShouldEmbedVideoLimitBannerRender = _this.getShouldEmbedVideoLimitBannerRender.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLoadMoreRows = _this.handleLoadMoreRows.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetch = _this.fetch.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BrowsePanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          maybeFetchFolders = _this$props.maybeFetchFolders,
          withPanelNavigator = _this$props.withPanelNavigator;
      maybeFetchFolders();

      if (!withPanelNavigator) {
        this.fetch({
          initial: true
        });
      }
    }
  }, {
    key: "handleCloseVideoLimitBanner",
    value: function handleCloseVideoLimitBanner() {
      this.setState({
        isVideoLimitBannerDismissed: true
      });
    }
  }, {
    key: "shouldVidyardBannerRender",
    value: function shouldVidyardBannerRender() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          vidyardTosStatus = _this$props2.vidyardTosStatus,
          hasVideoIntegrationScope = _this$props2.hasVideoIntegrationScope;
      return type === _Constants2.DrawerTypes.HUBL_VIDEO && hasVideoIntegrationScope && vidyardTosStatus !== _Constants.VidyardTosStatus.ACCEPTED;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props3 = this.props,
          fetchFiles = _this$props3.fetchFiles,
          type = _this$props3.type;
      fetchFiles(Object.assign({}, options, {
        type: type
      }));
    }
  }, {
    key: "getShouldEmbedVideoLimitBannerRender",
    value: function getShouldEmbedVideoLimitBannerRender() {
      var isVideoLimitBannerDismissed = this.state.isVideoLimitBannerDismissed;
      var _this$props4 = this.props,
          hasUserExceededVideoLimit = _this$props4.hasUserExceededVideoLimit,
          type = _this$props4.type;
      return (0, _hubLVideo.shouldVideoLimitBannerRender)({
        isVideoLimitBannerDismissed: isVideoLimitBannerDismissed,
        hasUserExceededVideoLimit: hasUserExceededVideoLimit,
        type: type
      });
    }
  }, {
    key: "getHeading",
    value: function getHeading() {
      var type = this.props.type;

      switch (type) {
        case _Constants2.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.panels.recentImages');

        case _Constants2.DrawerTypes.VIDEO:
        case _Constants2.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.panels.recentVideos');

        case _Constants2.DrawerTypes.DOCUMENT:
          return _I18n.default.text('FileManagerLib.panels.recentDocuments');

        default:
          return _I18n.default.text('FileManagerLib.panels.recentFiles');
      }
    }
  }, {
    key: "handleLoadMoreRows",
    value: function handleLoadMoreRows() {
      var _this$props5 = this.props,
          filesRequestStatus = _this$props5.filesRequestStatus,
          files = _this$props5.files;

      if (filesRequestStatus === _Constants.RequestStatus.PENDING) {
        return;
      }

      this.fetch({
        offset: files.count()
      });
    }
  }, {
    key: "renderVideoLimitBanner",
    value: function renderVideoLimitBanner(videoLimit) {
      return _react.default.createElement(_UIFireAlarm.default, {
        closeable: true,
        onClose: this.handleCloseVideoLimitBanner,
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: getVideoLimitBannerI18nKey('title')
        }),
        type: "warning",
        className: "m-bottom-6"
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedReactMessage.default, {
        message: getVideoLimitBannerI18nKey('message'),
        options: {
          limit: videoLimit,
          nextLimit: 500,
          filesLink: _react.default.createElement(_UILink.default, {
            href: (0, _network.getRedirectToFilesLocation)(),
            key: "link-to-files"
          }, _react.default.createElement(_FormattedMessage.default, {
            message: getVideoLimitBannerI18nKey('filesLink')
          }))
        }
      })));
    }
  }, {
    key: "renderVidyardBanner",
    value: function renderVidyardBanner() {
      var _this$props6 = this.props,
          inferredUserRole = _this$props6.inferredUserRole,
          _updateVidyardTosStatus = _this$props6.updateVidyardTosStatus,
          isFileManagerPortalDataUpdatePending = _this$props6.isFileManagerPortalDataUpdatePending,
          vidyardTosStatus = _this$props6.vidyardTosStatus,
          total = _this$props6.total;
      return _react.default.createElement(_PickerVidyardBanner.default, {
        hubLVideosCount: total,
        currentVidyardTosStatus: vidyardTosStatus,
        inferredUserRole: inferredUserRole,
        isFileManagerPortalDataUpdatePending: isFileManagerPortalDataUpdatePending,
        updateVidyardTosStatus: function updateVidyardTosStatus(vidyardTosSatus) {
          return _updateVidyardTosStatus(vidyardTosSatus);
        }
      });
    }
  }, {
    key: "renderFiles",
    value: function renderFiles() {
      var _this$props7 = this.props,
          tiles = _this$props7.tiles,
          total = _this$props7.total,
          onInsert = _this$props7.onInsert,
          filesRequestStatus = _this$props7.filesRequestStatus,
          type = _this$props7.type,
          disableUpload = _this$props7.disableUpload,
          previousSelectedFileId = _this$props7.previousSelectedFileId,
          withPanelNavigator = _this$props7.withPanelNavigator;

      if (filesRequestStatus === _Constants.RequestStatus.PENDING) {
        return _react.default.createElement(_UILoadingOverlay.default, {
          contextual: true
        });
      }

      if (filesRequestStatus === _Constants.RequestStatus.FAILED) {
        return _react.default.createElement(_LoadingFailed.default, null);
      }

      if (this.shouldVidyardBannerRender()) {
        return this.renderVidyardBanner(total);
      }

      if (filesRequestStatus === _Constants.RequestStatus.SUCCEEDED && total === 0) {
        return _react.default.createElement(_NoFiles.default, {
          type: type
        });
      }

      return _react.default.createElement(_FoldersAndFilesContainer.default, {
        type: type,
        tiles: tiles,
        total: total,
        onInsert: onInsert,
        onLoadMoreFiles: this.handleLoadMoreRows,
        disableUpload: disableUpload,
        withPanelNavigator: withPanelNavigator,
        previousSelectedFileId: previousSelectedFileId
      });
    }
  }, {
    key: "renderSuspensionAlert",
    value: function renderSuspensionAlert() {
      var canAppeal = this.props.canAppeal;
      var accountVerificationUrl = (0, _urls.getAccountVerificationUrl)();
      return _react.default.createElement(_UIAlert.default, {
        type: "danger",
        "data-test-id": "picker-suspension-alert",
        className: "m-top-4"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.suspension.banner.message"
      }), canAppeal && _react.default.createElement(_FormattedJSXMessage.default, {
        message: "FileManagerLib.suspension.banner.appealLink_jsx",
        elements: {
          UILink: _UILink.default
        },
        options: {
          accountVerificationUrl: accountVerificationUrl
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          browseFolders = _this$props8.browseFolders,
          type = _this$props8.type,
          isPanelInactive = _this$props8.isPanelInactive,
          videoLimit = _this$props8.videoLimit,
          filterType = _this$props8.filterType,
          isPortalSuspended = _this$props8.isPortalSuspended;
      return _react.default.createElement(_UIFlex.default, {
        direction: "column"
      }, !isPanelInactive && filterType !== _FileExtensionFilters.default.NONE && _react.default.createElement(_FilterHintMessage.default, {
        drawerType: type
      }), !isPanelInactive && _react.default.createElement(_SearchWithSuggestions.default, {
        type: type
      }), isPortalSuspended && this.renderSuspensionAlert(), _react.default.createElement(_UIBox.default, {
        className: "m-top-6 flex-column",
        grow: 1,
        alignSelf: "stretch"
      }, !isPanelInactive && _react.default.createElement(_UIMedia.default, {
        align: "baseline"
      }, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement("h5", null, this.getHeading())), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UILink.default, {
        onClick: browseFolders,
        "data-test-id": "browse-folders"
      }, _react.default.createElement(_Small.default, null, _I18n.default.text('FileManagerLib.browseFolders'))))), this.getShouldEmbedVideoLimitBannerRender() && this.renderVideoLimitBanner(videoLimit), this.renderFiles()));
    }
  }]);
  return BrowsePanel;
}(_react.Component);

BrowsePanel.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants2.DrawerTypes)).isRequired,
  files: _propTypes.default.instanceOf(_immutable.default.List),
  tiles: _propTypes.default.instanceOf(_immutable.default.List),
  filesRequestStatus: _propTypes.default.oneOf(Object.keys(_Constants.RequestStatus)),
  total: _propTypes.default.number.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  fetchFiles: _propTypes.default.func.isRequired,
  maybeFetchFolders: _propTypes.default.func.isRequired,
  browseFolders: _propTypes.default.func.isRequired,
  hasVideoIntegrationScope: _propTypes.default.bool.isRequired,
  vidyardTosStatus: _propTypes.default.oneOf(Object.keys(_Constants.VidyardTosStatus)).isRequired,
  isFileManagerPortalDataUpdatePending: _propTypes.default.bool.isRequired,
  inferredUserRole: _propTypes.default.string.isRequired,
  updateVidyardTosStatus: _propTypes.default.func.isRequired,
  isPanelInactive: _propTypes.default.bool.isRequired,
  hasUserExceededVideoLimit: _propTypes.default.bool.isRequired,
  videoLimit: _propTypes.default.number.isRequired,
  filterType: _propTypes.default.oneOf(Object.keys(_FileExtensionFilters.default)).isRequired,
  isPortalSuspended: _propTypes.default.bool.isRequired,
  canAppeal: _propTypes.default.bool.isRequired,
  disableUpload: _propTypes.default.bool.isRequired,
  withPanelNavigator: _propTypes.default.bool.isRequired,
  previousSelectedFileId: _propTypes.default.number
};
BrowsePanel.defaultProps = {
  isPanelInactive: false
};

var mapStateToProps = function mapStateToProps(state, props) {
  var files = (0, _Files.getFiles)(state);
  var tiles = (0, _Tiles.getTiles)(state, props);
  return {
    files: files,
    tiles: tiles,
    total: (0, _Tiles2.getTotalFilteredTiles)({
      savedFilesCount: (0, _Files.getFilesTotal)(state),
      files: files,
      tiles: tiles
    }),
    filterType: (0, _Filter.getFilterType)(state),
    filesRequestStatus: (0, _Files.getFetchFilesRequestStatus)(state),
    hasVideoIntegrationScope: (0, _Auth.getHasVideoIntegrationScope)(state),
    vidyardTosStatus: (0, _PortalMeta2.getVidyardTosStatus)(state),
    isFileManagerPortalDataUpdatePending: (0, _PortalMeta2.getFileManagerPortalDataUpdateRequestStatus)(state) === _Constants.RequestStatus.PENDING,
    inferredUserRole: (0, _IdentityRepository.getInferredUserRole)(state),
    hasUserExceededVideoLimit: (0, _Limits.getHasUserExceededEmbeddableVideoLimit)(state),
    videoLimit: (0, _Limits.getEmbeddableVideoLimit)(state),
    isPortalSuspended: (0, _Permissions.getIsReadOnlySuspended)(state),
    canAppeal: (0, _Suspension.getCanAppeal)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    browseFolders: function browseFolders() {
      dispatch(Actions.setPanel({
        activePanel: _Constants2.Panels.FOLDER,
        selectedFolder: (0, _FoldersAndFiles.getHomeFolder)()
      }));
    },
    maybeFetchFolders: function maybeFetchFolders() {
      dispatch(Actions.maybeFetchFolders());
    },
    fetchFiles: function fetchFiles(options) {
      var initial = options.initial,
          queryOpts = (0, _objectWithoutProperties2.default)(options, ["initial"]);
      var query = Object.assign({
        limit: _Constants2.DEFAULT_ROWS_TO_FETCH * _Constants2.IMAGE_COLUMN_COUNT
      }, queryOpts, {}, (0, _network.getProviderParam)(ownProps.type));

      if (initial) {
        dispatch(Actions.fetchInitialFiles(query, ownProps.type));
      } else {
        dispatch(Actions.fetchMoreFiles(query, ownProps.type));
      }
    },
    updateVidyardTosStatus: function updateVidyardTosStatus(status) {
      return dispatch((0, _PortalMeta.getUpdateVidyardTosStatus)(status));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BrowsePanel);

exports.default = _default;
module.exports = exports.default;